import React, { useState, useRef, useEffect } from 'react';
import { Button, Grid, Card, CardContent, Typography, Stack, Select, MenuItem, FormControl, InputLabel, NativeSelect, FormControlLabel, RadioGroup, Radio } from "@mui/material"
import { Box } from "@mui/system"
import { DataGrid, GridToolbarQuickFilter, GridEditInputCell, useGridApiContext } from "@mui/x-data-grid"
import { CustomButton } from "../../common/custom-button/customButton"
import CheckIcon from '@mui/icons-material/Check';
import { DEMAND_CONSTANTS } from '../../common/constants';
import { SAVE_PAYMENT_DETAILS } from '../../common/URLs';

import { loaderService } from '../../common/custom-loader/loader-service';
import { toast } from 'react-toastify';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { styled } from '@mui/material/styles';
import { DEMAND_VALIDATIONS } from '../../common/commonValidations';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import apiClient from '../../axios';

export const PaymentDetails = (props) => {
  let isPaymentPercentageEditable = false
  const uuid = localStorage.getItem('uuid');
  let selectedUrn = [];
  let updatedDashboardData = {};
  let arrTemp = [];
  let selectedPaymentMethod = ''
  const [pageSize, setPageSize] = React.useState(10);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
    const [isApiCalled, setIsApiCalled] = useState(false);
  const StyledBox = styled(Box)(({ theme }) => ({
    height: "inherit",
    width: '100%',
    '& .MuiDataGrid-cell--editing': {
      backgroundColor: 'rgb(255,215,115, 0.19)',
      color: '#1a3e72',
      '& .MuiInputBase-root': {
        height: '100%',
      },
    },
    '& .Mui-error': {
      backgroundColor: `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
      color: theme.palette.error.main,
    },
  }));

  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
    },
  }));

    function EditInputCell(props) {
          const { error, id, value: valueProp, field } = props;
          const [value, setValue] = useState(valueProp);
          const apiRef = useGridApiContext();
  
          const handleChange = (event) => {
              const newValue = event.target.value; 
              apiRef.current.setEditCellValue({ id, field, value: newValue });
              setValue(newValue);
          };
  
          useEffect(() => {
              setValue(valueProp);
          }, [valueProp]);
          
          return (
              <StyledTooltip open={!!error} title={error}>
                  <GridEditInputCell {...props} value={value} onChange={handleChange} />
             </StyledTooltip>
          );
      }

  function renderEdit(params) {
    return <EditInputCell {...params} />;
  }

  const poDetailsColdef = [
    {
      field: 'stakeholderUrn',
      headerName: 'URN',
      width: 150,
    },
    {
      field: 'stakeholderType',
      headerName: 'Stakeholder Type',
      width: 150,
    },
    {
      field: 'growerLandId',
      headerName: 'Land ID',
      width: 300,

    },
    {
      field: 'rate',
      headerName: 'Rate(INR per MT)',
      width: 150,
    },
    {
      field: 'qty',
      headerName: 'Qty(in MT)',
    },
    {
      width: 150,
      field: 'totalCost',
      headerName: 'Total Cost(in INR)',
    },
    {
      field: 'royaltypayment',
      headerName: 'Royalty Payment %',
      width: 150,
    },
    // {
    //   width: 180,
    //   field: 'paymentMethod',
    //   headerName: 'Payment Method *',
    //   renderCell: params => <PaymentSelectUI rowData={params.row}></PaymentSelectUI>
    // },
    {
      field: 'percentage',
      headerName: 'Advance Payment % *',
      editable: true,
      type: 'number',
      width: 170,
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.paymentValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      width: 180,
      field: 'paymentCycle',
      headerName: 'Payment Cycle*',
      renderCell: params => <PaymentCycleUI rowData={params.row}></PaymentCycleUI>
    },
    {
      field: 'deliveryTolerance',
      headerName: 'Delivery Tolerance %*',
      width: 150,
      type: 'number',
      editable: true,
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.paymentValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
  ]

  const QuickSearchToolbar = () => {
    return (
      <>
        <Box
          sx={{ p: 0.5, pb: 0, float: 'right' }}>
          <GridToolbarQuickFilter />
        </Box>
      </>
    );
  }

  const PaymentSelectUI = ({ rowData }) => {
    const [paymentMethod, setPaymentMethod] = useState(rowData.paymentMethod ? rowData.paymentMethod : 'select');
    const onHandlePaymentMethodSelect = (event) => {
      const selected = event.target.value;
      setPaymentMethod(selected);
      selectedPaymentMethod = selected;
      if (selected === DEMAND_CONSTANTS.INVOICE) {
        isPaymentPercentageEditable = false;
      }
      else {
        isPaymentPercentageEditable = true;
        selectedUrn.push(rowData.id)
      }
      let data = {
        "stakeholderUrn": rowData.stakeholderUrn,
        "stakeholderType": rowData.stakeholderType,
        "rate": rowData.rate,
        "qty": rowData.qty,
        "totalCost": rowData.totalCost,
        "paymentMethod": selected,
        "percentage": rowData.percentage,
        "paymentCycle": rowData.paymentCycle,
        "deliveryTolerance": rowData.deliveryTolerance,
        "growerLandId": rowData.growerLandId
      }
      if (arrTemp.length !== 0) {
        let filteredData = arrTemp?.filter(item => item.stakeholderUrn === data.stakeholderUrn && item.growerLandId === data.growerLandId)
        if (filteredData.length === 0) arrTemp.push(data);
        else {
          arrTemp.map((item) => {
            if (item.stakeholderUrn === data.stakeholderUrn && item.growerLandId === data.growerLandId) {
              item.paymentMethod = data.paymentMethod
            }
          })
        }
      } else { arrTemp.push(data) }
    }
    return (
      <FormControl fullWidth variant="standard">
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          style={{ fontSize: 14.7 }}
          value={paymentMethod}
          onChange={(e) => onHandlePaymentMethodSelect(e)}
        >
          <MenuItem value={'select'} disabled>---Select---</MenuItem>
          <MenuItem value={DEMAND_CONSTANTS.ADVANCEPAYMENT}>{DEMAND_CONSTANTS.ADVANCEPAYMENT}</MenuItem>
          <MenuItem value={DEMAND_CONSTANTS.ROYALTYPAYMENT}>{DEMAND_CONSTANTS.ROYALTYPAYMENT}</MenuItem>
          <MenuItem value={DEMAND_CONSTANTS.INVOICE}>{DEMAND_CONSTANTS.INVOICE}</MenuItem>
        </Select>
      </FormControl>
    )
  }
  const PaymentCycleUI = ({ rowData }) => {
    const [paymentCycle, setPaymentCycle] = useState(rowData.paymentCycle ? rowData.paymentCycle : 'select');
    const onHandlePaymentCycleRadio = (event) => {
      const selected = event.target.value;
      setPaymentCycle(selected);
      let data = {
        "stakeholderUrn": rowData.stakeholderUrn,
        "stakeholderType": rowData.stakeholderType,
        "rate": rowData.rate,
        "qty": rowData.qty,
        "totalCost": rowData.totalCost,
        "royaltypayment": rowData.royaltypayment,
        "paymentMethod": rowData.paymentMethod,
        "percentage": rowData.percentage,
        "paymentCycle": selected,
        "deliveryTolerance": rowData.deliveryTolerance,
        "growerLandId": rowData.growerLandId
      }
      if (arrTemp.length !== 0) {
        let filteredData = arrTemp?.filter(item => item.stakeholderUrn === data.stakeholderUrn && item.growerLandId === data.growerLandId)
        if (filteredData.length === 0) arrTemp.push(data);
        else {
          arrTemp.map((item) => {
            if (item.stakeholderUrn === data.stakeholderUrn && item.growerLandId === data.growerLandId) {
              item.paymentCycle = data.paymentCycle
            }
          })
        }
      } else { arrTemp.push(data) }
    }
    return (
      <FormControl fullWidth variant="standard">
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          style={{ fontSize: 14.7 }}
          value={paymentCycle}
          onChange={(e) => onHandlePaymentCycleRadio(e)}
        >
          <MenuItem value={'select'} disabled>---Select---</MenuItem>
          <MenuItem value={DEMAND_CONSTANTS.TWODAYS}>{DEMAND_CONSTANTS.TWODAYS}</MenuItem>
          <MenuItem value={DEMAND_CONSTANTS.FORTNIGHTLY}>{DEMAND_CONSTANTS.FORTNIGHTLY}</MenuItem>
          <MenuItem value={DEMAND_CONSTANTS.MONTHLY}>{DEMAND_CONSTANTS.MONTHLY}</MenuItem>

        </Select>
      </FormControl>
    )
  }
  const confirmButtonClick = () => {
    let isDataValid = arrTemp.map((item) => {
      if (item.deliveryTolerance && item.paymentCycle && item.paymentMethod) {
        if (item.paymentMethod !== DEMAND_CONSTANTS.INVOICE && item.percentage) return true
        else if (item.paymentMethod === DEMAND_CONSTANTS.INVOICE) return true
        else return false
      } else return false
    })
    if (isDataValid.includes(false)) {
      toast.error('Please fill all details')
    } else
      handleLogModalOpen();
  }

  // const onConfirmSubmit = () => {
  //   handleLogModalClose();
  //   savePaymentDetailsApi()
  // }

 
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await savePaymentDetailsApi();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen(false);
            setIsApiCalled(false);
        }
    };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow };
    return updatedDashboardData = updatedRow
  };

  const onCellEditStop = (params, event) => {
    if (params.field === "percentage") {
      let data = {
        "stakeholderUrn": params.row.stakeholderUrn,
        "stakeholderType": params.row.stakeholderType,
        "rate": params.row.rate,
        "qty": params.row.qty,
        "totalCost": params.row.totalCost,
        "royaltypayment": params.row.royaltypayment,
        "paymentMethod": params.row.paymentMethod,
        "percentage": parseFloat(event.target.value),
        "paymentCycle": params.row.paymentCycle,
        "deliveryTolerance": params.row.deliveryTolerance,
        "growerLandId": params.row.growerLandId
      }
      if (arrTemp.length !== 0) {
        let filteredData = arrTemp?.filter(item => item.stakeholderUrn === data.stakeholderUrn && item.growerLandId === data.growerLandId)
        if (filteredData.length === 0) arrTemp.push(data);
        else {
          arrTemp.map((item) => {
            if (item.stakeholderUrn === data.stakeholderUrn && item.growerLandId === data.growerLandId) {
              item.percentage = data.percentage
            }
          })
        }
      } else { arrTemp.push(data) }
    } else if (params.field === "deliveryTolerance") {
      let data = {
        "stakeholderUrn": params.row.stakeholderUrn,
        "stakeholderType": params.row.stakeholderType,
        "rate": params.row.rate,
        "qty": params.row.qty,
        "totalCost": params.row.totalCost,
        "royaltypayment": params.row.royaltypayment,
        "paymentMethod": params.row.paymentMethod,
        "percentage": params.row.percentage,
        "paymentCycle": params.row.paymentCycle,
        "deliveryTolerance": parseFloat(event.target.value),
        "growerLandId": params.row.growerLandId
      }
      if (arrTemp.length !== 0) {
        let filteredData = arrTemp?.filter(item => item.stakeholderUrn === data.stakeholderUrn && item.growerLandId === data.growerLandId)
        if (filteredData.length === 0) arrTemp.push(data);
        else {
          arrTemp.map((item) => {
            if (item.stakeholderUrn === data.stakeholderUrn && item.growerLandId === data.growerLandId) {
              item.deliveryTolerance = data.deliveryTolerance
            }
          })
        }
      } else { arrTemp.push(data) }
    }

  }

  // -----------------API Calls-------------------

  const savePaymentDetailsApi = async () => {
    loaderService.showLoader();
    arrTemp.map((item) => {
      if (item.paymentMethod === DEMAND_CONSTANTS.INVOICE) {
        item.percentage = null
      }
    })
    await apiClient.post(SAVE_PAYMENT_DETAILS + `?userId=${uuid}`,
      {
        "financialYear": props.year,
        "month": props.month,
        "planningNumber": props.planningNumber,
        "paymentLst": arrTemp
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        if (response.data.isSuccess === true) toast.success(response.data.message)
        else if (response.data.isSuccess === false) toast.error(response.data.message)
        props.getPaymentDetailsApi(props.year, props.month, props.planningNumber);
        loaderService.hideLoader();
      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={12}>
        <Card>
          <CardContent>
            <Stack direction='row' style={{ justifyContent: 'space-between', marginBottom: 10 }}>
              <Typography variant='subtitle1'>Payment Details</Typography>
              <Button startIcon={<CheckIcon />} variant="contained" onClick={() => confirmButtonClick()}>Confirm</Button>
            </Stack>
            <Box sx={{
              height: 650, width: '100%',
              '& .MuiDataGrid-cell--editable': {
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
              },
              '& .Mui-error': {
                                backgroundColor: `rgb(126,10,15,0.1)`,
                                color: (theme) => theme.palette.error.main,
                            },
            }}>
             
                <DataGrid
                  rows={props.data ? props.data : []}
                  columns={poDetailsColdef}
                  pagination
                  processRowUpdate={(e) => processRowUpdate(e)}
                  experimentalFeatures={{ newEditingApi: true }}
                  pageSize={pageSize}
                  components={{ Toolbar: QuickSearchToolbar }}
                  onPageSizeChange={(newPage) => setPageSize(newPage)}
                  onCellEditStop={(params, event) => {
                    onCellEditStop(params, event)
                  }}
                />
              
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmSubmit} onClose={handleLogModalClose} action="Change Password" />
    </Grid>

  )
}